import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

export default function CTA() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-[800px] mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4 leading-tight">
          {t('cta.title')}
        </h2>
        <p className="text-sm md:text-base text-foreground-600 mb-10 max-w-lg mx-auto leading-relaxed">
          {t('cta.subtitle')}
        </p>
        <a
          href={mainSiteUrl}
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2.5 px-10 py-4 text-base font-semibold text-background-50 bg-primary-500 rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          {t('cta.button')}
          <i className="ri-arrow-right-up-line text-lg"></i>
        </a>

        {/* Bottom product strip image */}
        <div className="mt-16 w-full overflow-hidden rounded-2xl">
          <img
            src="https://readdy.ai/api/search-image?query=Horizontal%20editorial%20still%20life%20arrangement%20of%20curated%20lifestyle%20products%20leather%20goods%20ceramic%20vessels%20dried%20botanicals%20art%20books%20on%20warm%20oak%20surface%20soft%20diffused%20natural%20window%20light%20elegant%20neutral%20palette%20beige%20taupe%20cream%20terracotta%20tones%20sophisticated%20composition&width=1400&height=400&seq=cta-strip-v2&orientation=landscape&nocache=true"
            alt="OOPBUY Spreadsheet products"
            className="w-full h-auto object-cover object-top"
          />
        </div>
      </div>
    </section>
  );
}